import SubHero from "@components/SubHero/SubHero";
import React from "react";
import './RecruiterPage.scss'
import TargetAudience from "@components/TargetAudience/TargetAudience";
import WhyAuto from "@components/WhyAuto/WhyAuto";
import Contact from "@components/Contact/Contact";

const RecruiterPage: React.FC = () => {
    return (
        <>  
            <div className="subhero-audience-section">
                <SubHero/>
                <TargetAudience />
            </div>
            <WhyAuto/>
            <Contact/>
        </>
    )
}

export default RecruiterPage;
